module.exports = __webpack_public_path__ + "static/media/bomb.8c4a8b87.png";